module.exports = __webpack_public_path__ + "img/f867889d27641134eae670183ffbf242.f867889d.png";